import { Typography } from '@app/components';
import { EPlanLimitType } from '@app/domain/plan/components/plan-limit-dialog/PlanLimitDialog';
import { UpgradeBanner } from '@app/domain/plan/components/UpgradeBanner';
import { usePlanLimits } from '@app/domain/plan/hooks/usePlanLimits';
import { AccountTeamManagement } from '@app/domain/team/components/AccountTeamManagement';
import { useTranslation } from 'react-i18next';

export const AccountTeam: React.FC = () => {
  const { t } = useTranslation();
  const { canUseTeam } = usePlanLimits();

  return (
    <div className="flex flex-col gap-4">
      <Typography className="font-bold text-gray-800 text-xxxl pl-6 lg:pl-0">{t('team.title')}</Typography>
      <div className="flex flex-col gap-4">
        {!canUseTeam && <UpgradeBanner planLimitDialogType={EPlanLimitType.TEAM} className="lg:rounded-xl" />}
        <AccountTeamManagement />
      </div>
    </div>
  );
};
